function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.461 19.6667L33.7305 0.333374L0 19.6667V58.3334L33.7305 77.6667L67.461 58.3334V19.6667ZM2.30145 57.0142V20.9858L33.7305 2.97162L65.1595 20.9858V57.0142L33.7305 75.0285L2.30145 57.0142ZM32.588 20.8913L25.3296 16.7322L18.0712 20.8913V29.2239L25.3296 33.383L32.588 29.2239V20.8913ZM48.9296 20.8913L41.671 16.7322L34.4128 20.8913V29.2239L41.671 33.383L48.9296 29.2239V20.8913ZM36.6128 22.1663L41.671 19.2678L46.7296 22.1663V27.9489L41.671 30.8474L36.6128 27.9489V22.1663ZM20.2712 22.1663L25.3296 19.2678L30.388 22.1663V27.9489L25.3296 30.8474L20.2712 27.9489V22.1663ZM24.4172 34.6913L17.1588 30.5322L9.90039 34.6913V43.0241L17.1588 47.1832L24.4172 43.0241V34.6913ZM57.1004 34.6913L49.8417 30.5322L42.5836 34.6913V43.024L49.8417 47.1832L57.1004 43.0241V34.6913ZM40.7588 34.6913L33.5002 30.5322L26.242 34.6913V43.024L33.5002 47.1832L40.7588 43.0241V34.6913ZM44.7836 35.9663L49.8418 33.0678L54.9004 35.9663V41.7491L49.8418 44.6476L44.7836 41.7491V35.9663ZM28.442 35.9663L33.5002 33.0678L38.5588 35.9663V41.7491L33.5002 44.6476L28.442 41.7491V35.9663ZM12.1004 41.7491V35.9663L17.1588 33.0678L22.2172 35.9663V41.7491L17.1588 44.6476L12.1004 41.7491ZM32.588 48.776L25.3296 44.6169L18.0712 48.776V57.1086L25.3296 61.2678L32.588 57.1086V48.776ZM48.9296 48.776L41.671 44.6169L34.4128 48.776V57.1086L41.671 61.2678L48.9296 57.1086V48.776ZM36.6128 50.051L41.671 47.1525L46.7296 50.051V55.8336L41.671 58.7322L36.6128 55.8337V50.051ZM20.2712 55.8337V50.051L25.3296 47.1525L30.388 50.051V55.8337L25.3296 58.7322L20.2712 55.8337Z",
  fill: "url(#paint0_radial_7089_139073)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_7089_139073",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.000360075 -62.0009) rotate(67.1443) scale(252.31 13797.7)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B6F4FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#943EB7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D2347"
})));

function SvgInternetOfBlockchains(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 78,
    viewBox: "0 0 68 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetOfBlockchains);
export default __webpack_public_path__ + "static/media/InternetOfBlockchains.456972d84257be5a9c25b28c6c734b84.svg";
export { ForwardRef as ReactComponent };